'use es6';

/**
 * Temporary vendored file for react-dnd-preview@8.0.0
 * - source: https://unpkg.com/react-dnd-preview@8.0.0
 * - docs: https://git.hubteam.com/HubSpot/bender-repackages#alternatives-to-repackaging
 */

/* eslint-disable */

import c from 'react';
import { useRef as m } from 'react';
import { useDragLayer as f } from 'react-dnd';
const i = (t, e) => ({ x: t.x - e.x, y: t.y - e.y });
const a = (t) => {
  const e = t.getInitialClientOffset();
  const r = t.getInitialSourceClientOffset();
  return e === null || r === null ? { x: 0, y: 0 } : i(e, r);
};
const u = (t, e) => {
  const r = t.getClientOffset();
  if (r === null) return null;
  if (!e.current || !e.current.getBoundingClientRect) return i(r, a(t));
  const n = e.current.getBoundingClientRect();
  const o = { x: n.width / 2, y: n.height / 2 };
  return i(r, o);
};
const p = (t) => {
  const e = `translate(${t.x.toFixed(1)}px, ${t.y.toFixed(1)}px)`;
  return {
    pointerEvents: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    transform: e,
    WebkitTransform: e,
  };
};
const l = () => {
  const t = m(null);
  const e = f((r) => ({
    currentOffset: u(r, t),
    isDragging: r.isDragging(),
    itemType: r.getItemType(),
    item: r.getItem(),
    monitor: r,
  }));
  return !e.isDragging || e.currentOffset === null
    ? { display: !1 }
    : {
        display: !0,
        itemType: e.itemType,
        item: e.item,
        style: p(e.currentOffset),
        monitor: e.monitor,
        ref: t,
      };
};
import { createContext as P } from 'react';
const s = P(void 0);
const x = (t) => {
  const e = l();
  if (!e.display) return null;
  const { display: r, ...n } = e;
  let o;
  return (
    'children' in t
      ? typeof t.children === 'function'
        ? (o = t.children(n))
        : (o = t.children)
      : (o = t.generator(n)),
    c.createElement(s.Provider, { value: n }, o)
  );
};
export { s as Context, x as Preview, l as usePreview };
